var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17061",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17061",
    transform: "translate(-9960 8606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17060",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17060",
    transform: "translate(0 88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15222",
    "data-name": "\\u9577\\u65B9\\u5F62 15222",
    width: 61,
    height: 61,
    transform: "translate(9960 -8694)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Speaker",
    transform: "translate(9960.5 -8602.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24850",
    "data-name": "\\u30D1\\u30B9 24850",
    d: "M4.792,16.355h9.167L27.423,5.583a2.292,2.292,0,0,1,3.724,1.79V45.964a2.292,2.292,0,0,1-3.724,1.79L13.959,36.981H4.792A2.292,2.292,0,0,1,2.5,34.689V18.646A2.292,2.292,0,0,1,4.792,16.355Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24851",
    "data-name": "\\u30D1\\u30B9 24851",
    d: "M20.3,9.2a17.185,17.185,0,0,1,0,24.307",
    transform: "translate(22.997 5.317)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24852",
    "data-name": "\\u30D1\\u30B9 24852",
    d: "M23.132,6.368a26.365,26.365,0,0,1,0,37.273",
    transform: "translate(26.652 1.663)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24853",
    "data-name": "\\u30D1\\u30B9 24853",
    d: "M17.475,12.025a8.026,8.026,0,0,1,0,11.344",
    transform: "translate(19.344 8.971)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.7f8f3d9767d5d36ffa2ef36da7af06a2.svg";
export { ForwardRef as ReactComponent };